import { computed, type MaybeRefOrGetter, toValue } from "vue";
import type { DisabledRule } from "@/types/validation";

export function useDisableReasons(rules: MaybeRefOrGetter<DisabledRule[]>, allReasons = true) {
  const checkIsRuleDisabled = (rule: DisabledRule) => {
    return typeof rule.disabled === "function" ? rule.disabled() : rule.disabled;
  };

  const rulesRef = computed(() => toValue(rules));

  const isDisabled = computed(() => {
    if (!rulesRef.value.length) {
      return true;
    }

    return rulesRef.value.some((rule) => checkIsRuleDisabled(rule));
  });

  const disabledReasons = computed<string[] | string>(() => {
    const activeRules = rulesRef.value.filter((rule) => checkIsRuleDisabled(rule) && rule.reason);

    if (!activeRules.length) {
      return "";
    }

    return allReasons ? activeRules.map((rule) => rule.reason) : activeRules[0].reason;
  });

  return {
    isDisabled,
    disabledReasons,
  };
}
